export default __webpack_public_path__ + "static/media/techspace.6c6a43c8.PNG";